import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    parametros: {},
    regrasComerciais: [],
    qz3: [],
    qz4: [],
    qz5: [],
    qz6: [],
    qz7: [],
    szy: [],
    condicoesPagamento: [],
    embalagens: [],
    valorMinimo: 1,
    admin: {},
    menu: [],
    vendedor: {}
  },
  mutations: {
    setParametros: (state, parametros) => {
      state.parametros = parametros
    },
    setVendedor: (state, vendedor) => {
      state.vendedor = vendedor
    },
    setMenu: (state, menu) => {
      state.menu = menu
    },
    setRegrasComerciais: (state, regras) => {
      state.regrasComerciais = regras.qz5
      state.qz3 = regras.qz3
      state.qz4 = regras.qz4
      state.qz5 = regras.qz5
      state.qz6 = regras.qz6
      state.qz7 = regras.qz7
      state.szy = regras.szy
      state.condicoesPagamento = regras.condicoes_pagamento
      state.embalagens = regras.embalagens
      state.parametros = regras.parametro_portal
      state.valorMinimo = regras.qz5.reduce(
        (min, z5) => parseFloat(z5.QZ5_VLRMIN) < parseFloat(min) ? z5.QZ5_VLRMIN : min, regras.qz5[0].QZ5_VLRMIN)
    },
    setEmbalagens: (state, embalagens) => {
      state.embalagens = embalagens
    },
    setValorMinimo: (state, valor) => {
      state.valorMinimo = valor
    },
    setAdmin: (state, admin) => {
      state.admin = admin
    }
  },
  actions: {
    setParametros: (context, parametros) => {
      context.commit('setParametros', parametros)
    },
    setVendedor: (context, vendedor) => {
      context.commit('setVendedor', vendedor)
    },
    setMenu: (context, menu) => {
      context.commit('setMenu', menu)
    },
    setRegrasComerciais: (context, regras) => {
      context.commit('setRegrasComerciais', regras)
    },
    setEmbalagens: (context, embalagens) => {
      context.commit('setEmbalagens', embalagens)
    },
    setValorMinimo: (context, valor) => {
      context.commit('setValorMinimo', valor)
    },
    setAdmin: (context, admin) => {
      context.commit('setAdmin', admin)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js